import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function BookmarkManagerIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M14.401 20.992v-1.65q0-.2.075-.387a1 1 0 0 1 .225-.338l5.225-5.2q.225-.225.5-.325.276-.1.55-.1a1.5 1.5 0 0 1 1.075.45l.925.925q.2.225.313.5t.112.55-.1.563a1.34 1.34 0 0 1-.325.512l-5.2 5.2q-.15.15-.337.225t-.388.075h-1.65a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713m6.575-4.6.925-.975-.925-.925-.95.95zm-16.575 3.6q-.824 0-1.412-.587a1.93 1.93 0 0 1-.588-1.413v-12q0-.824.588-1.412A1.93 1.93 0 0 1 4.4 3.992h5.175a1.98 1.98 0 0 1 1.4.575L12.4 5.992h8q.825 0 1.413.588.587.587.587 1.412v2.075q0 .45-.362.725-.363.275-.838.2h-.275q-.7 0-1.312.25-.614.25-1.113.75l-5.525 5.525a1.98 1.98 0 0 0-.575 1.4v.075q0 .425-.287.713a.97.97 0 0 1-.713.287z" fill="currentColor" />
    </BaseIcon>
  )
}
